import Box from "@mui/material/Box";
import { type FC, type PropsWithChildren, type Ref } from "react";


export type ModalContentProps = PropsWithChildren<{
	scrollRef?: Ref<HTMLElement>;
	forceFullView?: boolean;
}>

export const ModalContent: FC<ModalContentProps> = ({
	children,
	scrollRef,
	forceFullView = false,
}) => {
	return (
		<Box
			ref={scrollRef}
			sx={{
				flexGrow: 1,
				overflowY: "auto",
				py: forceFullView ? 0 : 7,
				px: forceFullView ? 0 : 4,
			}}
		>
			{children}
		</Box>
	);
};

